(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lpo-pdp-reassurance"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function arm(video) {
    if (video.dataset.fondlySound) return;
    video.dataset.fondlySound = '1';

    var unmuted = false;

    function soundOn() {
      if (unmuted) return;
      unmuted = true;
      video.muted = false;
      video.defaultMuted = false;
      video.volume = 1;
      video.controls = true;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }

    video.addEventListener('click', soundOn, { once: true });
    video.addEventListener('touchend', soundOn, { once: true });

    var wrapper = video.closest('deferred-media, [id*="Deferred"], .deferred-media');
    if (wrapper) {
      wrapper.addEventListener('click', function () {
        setTimeout(soundOn, 50);
      }, { once: true });
    }
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('main video').forEach(arm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) { scan(); break; }
    }
  }).observe(document.body, { subtree: true, childList: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpo-pdp-v2-shell"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function arm(video) {
    if (video.dataset.fondlySound) return;
    video.dataset.fondlySound = '1';

    var unmuted = false;

    function soundOn() {
      if (unmuted) return;
      unmuted = true;
      video.muted = false;
      video.defaultMuted = false;
      video.volume = 1;
      video.controls = true;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }

    video.addEventListener('click', soundOn, { once: true });
    video.addEventListener('touchend', soundOn, { once: true });

    var wrapper = video.closest('deferred-media, [id*="Deferred"], .deferred-media');
    if (wrapper) {
      wrapper.addEventListener('click', function () {
        setTimeout(soundOn, 50);
      }, { once: true });
    }
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('main video').forEach(arm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) { scan(); break; }
    }
  }).observe(document.body, { subtree: true, childList: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
